module.exports = __webpack_public_path__ + "media/images/befit-logo@2x-db5e5c95d55a528ee340322a59f7a849.webp";